/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Hidden,
  IconButton,
  LinearProgress,
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PhoneIcon from '@material-ui/icons/Phone';
import AppBar from '@material-ui/core/AppBar';
import { ApiActions } from '@orientaction/api-actions';
import { Footer } from '@orientaction/components';
import { useTest } from '@orientaction/hooks';
import { getFromLS, isAdmin, publicLogoPath } from '@orientaction/utils';
import clsx from 'clsx';
import floor from 'lodash/floor';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import AppHeader from '../../pages/Redesign/shared/header';
import style from './style';

const Layout = ({
  children,
  isaddBackground,
  noPadding,
  classname,
  isNew,
  isNew2,
  showLink = true,
  footer,
  isNew3,
  isClassic,
  showOverFlow = false,
  useHeader = true,
  showProgressBar = false,
  isV2 = false,
  disableOverflowX = false,
  isUserConnected = true,
}: any) => {
  const history = useHistory();
  const { progress } = useTest();
  const cls = style();
  const user = JSON.parse(getFromLS('userInfos') || '{}');
  const mainLink = isAdmin(user) ? '/admin/users-resultats' : '/main';
  const dispatch = useDispatch();

  const redirectUser = () => {
    dispatch(ApiActions.setTabLayout(0 as any));
    history.push(user ? mainLink : '/');
  };

  return (
    <div className={clsx(cls.layout, classname)} style={disableOverflowX ? { overflowX: 'hidden' } : {}}>
      <div
        className={clsx(
          cls.content,
          isaddBackground ? cls.grayBG : null,
          noPadding ? cls.noPadding : null,
          isNew ? cls.imageBG : null,
          isNew2 ? cls.imageBG2 : null,
          isNew3 ? cls.imageBG3 : null,
          isClassic ? cls.imageClassic : null,
          isV2 ? cls.bgV2 : null,
        )}>
        {useHeader && showProgressBar && (
          <AppBar
            position="sticky"
            color="transparent"
            elevation={0}
            className={`${cls.appBar} ${cls.appBarWithProgress}`}>
            <nav className={cls.navbar}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                  flexWrap: 'nowrap',
                  overflow: 'hidden',
                  justifyContent: 'space-between',
                }}>
                <div
                  className={cls.logoContainer}
                  onClick={redirectUser}
                  style={{ flexShrink: 0 }}>
                  <picture className={cls.logo}>
                    <source srcSet={`${publicLogoPath}/e-orientaction-redesign.png`} />
                    <img
                      src={`${publicLogoPath}/e-orientaction-redesign.png`}
                      alt="logo-orientation"
                      className={cls.logoImg}
                    />
                  </picture>
                </div>

                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    flex: '1 1 auto',
                    minWidth: '100px',
                    maxWidth: '600px',
                    marginLeft: 'auto',
                    marginRight: '-10%',
                  }}
                  className={cls.progressContainer}>
                  <div style={{ width: '100%', minWidth: 0 }}>
                    <LinearProgress
                      classes={{
                        colorPrimary: cls.colorPrimary,
                        barColorPrimary: cls.barColorPrimary,
                      }}
                      variant="determinate"
                      value={progress}
                    />
                  </div>
                  <p
                    style={{
                      marginLeft: '8px',
                      whiteSpace: 'nowrap',
                      flexShrink: 0,
                      marginRight: '8px',
                    }}>
                    {floor(progress)}%
                  </p>
                </div>

                <Hidden only={['xs', 'sm']}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '20px',
                      flexShrink: 0,
                      marginLeft: 'auto',
                    }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        whiteSpace: 'nowrap',
                      }}>
                      <PhoneIcon style={{ fontSize: '18px', flexShrink: 0 }} />
                      <div style={{ textAlign: 'left', lineHeight: 1.2 }}>
                        <div style={{ whiteSpace: 'nowrap' }}>02 43 72 25 88*</div>
                        <div style={{ fontSize: '12px', whiteSpace: 'nowrap' }}>
                          *Numéro national non surtaxé
                        </div>
                      </div>
                    </div>
                    <Button
                      className={cls.btnContacter}
                      onClick={() =>
                        window.open('https://www.orientaction-groupe.com/contact/', '_blank')
                      }>
                      <MailOutlineIcon style={{ fontSize: '18px' }} />
                      <span
                        style={{
                          textAlign: 'left',
                          lineHeight: 1.2,
                          marginLeft: 10,
                          fontSize: '12px',
                        }}>
                        <div>Nous</div>
                        <div>Contacter</div>
                      </span>
                    </Button>
                  </div>
                </Hidden>

                <Hidden only={['xl', 'lg', 'md']}>
                  <IconButton
                    className={cls.btnIcon}
                    onClick={() => history.push('/user/tests')}
                    style={{ marginLeft: 'auto' }}>
                    <ClearIcon className={cls.styleIcon} />
                  </IconButton>
                </Hidden>
              </div>
            </nav>
          </AppBar>
        )}

        {useHeader && !showProgressBar && (
          <AppHeader showNav={showLink} isUserConnected={isUserConnected} />
        )}

        <div className={cls.children} style={{ overflow: showOverFlow ? 'visible' : 'auto' }}>
          {children}
          {footer && <Footer />}
        </div>
      </div>
    </div>
  );
};

export default Layout;
